"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConversation = useConversation;
var _ConversationProvider = require("./ConversationProvider");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Public hook for consuming components. `selectConversation` replaces the old
// 18-positional-argument `chatSelectionHandler` — callers pass one object:
//   selectConversation({ id, kind: "group", name, logo, roomId, groupModeratorId, ... })
function useConversation() {
  const ctx = (0, _ConversationProvider.useConversationContext)();
  const state = ctx.state;
  return _objectSpread(_objectSpread({}, ctx), {}, {
    screen: state.screen,
    conversation: state.conversation,
    requireResponseChatIds: state.requireResponseChatIds,
    isUnreadActive: state.isUnreadActive,
    isWelcome: state.screen === "welcome",
    isAi: state.screen === "ai",
    isContact: state.screen === "contact",
    isGroup: state.screen === "group",
    isTask: state.screen === "task"
  });
}